import { c as _c } from "react/compiler-runtime";
import { stegaClean } from "next-sanity";
import { MarketingPopupColourBlock } from "./marketing-popup-colour-block.component";
import { MarketingPopupEditorialSplit } from "./marketing-popup-editorial-split.component";
import { MarketingPopupGlass } from "./marketing-popup-glass.component";
import { MarketingPopupImmersive } from "./marketing-popup-immersive.component";
import { MarketingPopupSignatureShape } from "./marketing-popup-signature-shape.component";
import type { MarketingPopupVariantProps } from "./marketing-popup.types";
export function MarketingPopupCard(t0) {
  const $ = _c(15);
  const {
    popup,
    className,
    onClose,
    onCtaClick
  } = t0;
  const variant = stegaClean(popup.variant) ?? "editorial-split";
  let t1;
  if ($[0] !== className || $[1] !== onClose || $[2] !== onCtaClick || $[3] !== popup) {
    t1 = {
      popup,
      className,
      onClose,
      onCtaClick
    };
    $[0] = className;
    $[1] = onClose;
    $[2] = onCtaClick;
    $[3] = popup;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const props = t1;
  switch (variant) {
    case "immersive-full-bleed":
      {
        let t2;
        if ($[5] !== props) {
          t2 = <MarketingPopupImmersive {...props} />;
          $[5] = props;
          $[6] = t2;
        } else {
          t2 = $[6];
        }
        return t2;
      }
    case "colour-block":
      {
        let t2;
        if ($[7] !== props) {
          t2 = <MarketingPopupColourBlock {...props} />;
          $[7] = props;
          $[8] = t2;
        } else {
          t2 = $[8];
        }
        return t2;
      }
    case "signature-shape":
      {
        let t2;
        if ($[9] !== props) {
          t2 = <MarketingPopupSignatureShape {...props} />;
          $[9] = props;
          $[10] = t2;
        } else {
          t2 = $[10];
        }
        return t2;
      }
    case "glass":
      {
        let t2;
        if ($[11] !== props) {
          t2 = <MarketingPopupGlass {...props} />;
          $[11] = props;
          $[12] = t2;
        } else {
          t2 = $[12];
        }
        return t2;
      }
    default:
      {
        let t2;
        if ($[13] !== props) {
          t2 = <MarketingPopupEditorialSplit {...props} />;
          $[13] = props;
          $[14] = t2;
        } else {
          t2 = $[14];
        }
        return t2;
      }
  }
}